import React, { FC } from 'react';

type Props = {
  children: React.ReactNode;
};
const ChangeHeaderCell: FC<Props> = ({ children }) => {
  return (
    <th className="tw-border-b tw-border-grayscale-20 tw-px-3 tw-pb-1">
      <p className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-grayscale-180 ">
        {children}
      </p>
    </th>
  );
};

export default ChangeHeaderCell;
